<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.date_after"
          :label="$t('global.datestart')"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.date_before"
          :label="$t('global.dateend')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.address"
          :label="$t('administration.backup.address')"
          type="text"
          @focus="onInputFocus"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-radio-group v-model="item.success" row :label="$t('administration.backup.success')">
          <v-radio
            :label="$t('global.true')"
            value="true"
          ></v-radio>
          <v-radio
            :label="$t('global.false')"
            value="false"
          ></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import InputDate from '../InputDate';


export default {
  name: 'BackupFilter',
  mixins: [],
  components: {
    InputDate,
  },
  props: {
    values: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  mounted() {
  },

  computed: {
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    }
  },
  methods: {
  }
};
</script>
